<div class="form-check" [class.form-check--tablet]="variant === 'tablet'">
  <input
    type="checkbox"
    [id]="label"
    [name]="label"
    [formControl]="formControl" />
  <svg
    class="form-check__checkbox"
    width="32"
    height="32"
    viewBox="-4 -4 39 39"
    aria-hidden="true">
    <!-- The background -->
    <rect
      class="cb-background"
      width="35"
      height="35"
      x="-2"
      y="-2"
      stroke="currentColor"
      fill="none"
      stroke-width="3"
      rx="6"
      ry="6"></rect>
    <path
      class="cb-checkmark"
      fill="none"
      d="M14.1 27.2l7.1 7.2 16.7-16.8"
      transform="translate(-10, -10)"></path>
  </svg>
  <label [for]="label" class="form-check__label">{{
    checkboxLabel || label | applyProvidedPipe : pipe
  }}</label>
</div>
